"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var INumeralTextRender = (function (_super) {
    __extends(INumeralTextRender, _super);
    function INumeralTextRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    INumeralTextRender.prototype.isInteger = function (isInt) {
        throw new Error("Not implemented!");
    };
    return INumeralTextRender;
}(zebra.ui.TextRender));
exports.INumeralTextRender = INumeralTextRender;
exports.numeralTextRender = zebra.Class(zebra.ui.TextRender, [
    function (text, isInteger) {
        this.setStandardRegexes();
        this.setRegexStrings();
        if (isInteger !== undefined) {
            this.isInteger(isInteger);
        }
        this.$super(text);
    },
    function isInteger(isInt) {
        this._isInteger = isInt;
        this.setRegexStrings();
    },
    function setStandardRegexes() {
        this._floatCleanup = /[^0-9,+\-\/\*%]+/;
        this._floatFilter = "[+\-\/\*]?[0-9]*,?[0-9]*[%+\-\/\*]?";
        this._integerCleanup = /[^0-9+\-\/\*%]+/;
        this._integerFilter = "[+\-\/\*]?[0-9]*[%+\-\/\*]?";
    },
    function setRegexStrings() {
        this._cleanupString = this._floatCleanup;
        this._filterString = this._floatFilter;
        if (this._isInteger && this._isInteger === true) {
            this._cleanupString = this._integerCleanup;
            this._filterString = this._integerFilter;
        }
    },
    function textUpdated(src, b, off, size, ful, updatedLines) {
        var theValue = src.getValue();
        if (theValue.indexOf("*") !== -1 || theValue.indexOf("/") !== -1) {
            this._cleanupString = this._floatCleanup;
            this._filterString = this._floatFilter;
        }
        var theNewValue = theValue.replace(new RegExp(this._cleanupString), "");
        var theMatch = theNewValue.match(this._filterString);
        if (theMatch !== null) {
            src.setValue(theMatch[0]);
            this.$super(src, b, off, size, ful, updatedLines);
        }
    }
]);
//# sourceMappingURL=numeralTextRender.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/uiElements/numeralTextRender.js
// module id = 28
// module chunks = 0